var _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToggleWeekCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "22.088px",
    height: "22.115px",
    viewBox: "14.324 3.442 22.088 22.115",
    enableBackground: "new 14.324 3.442 22.088 22.115",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M25.38,3.442c6.106,0,11.057,4.951,11.057,11.057c0,6.107-4.951,11.059-11.057,11.059 c-6.106,0-11.057-4.951-11.057-11.059l0,0C14.324,8.394,19.274,3.442,25.38,3.442z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-444.879 -433.727)",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(546.985 535.728)",
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8716D",
    stroke: "#E8716D",
    strokeWidth: 0.5,
    d: "M-71.381-80.139c0.804,0.006,1.46-0.641,1.466-1.445v-10.469 c-0.006-0.803-0.662-1.449-1.466-1.444h-10.688c-0.803-0.005-1.459,0.642-1.466,1.444v10.469c0.007,0.805,0.663,1.451,1.466,1.445 H-71.381z M-82.927-81.584v-10.469c0.004-0.47,0.388-0.848,0.858-0.845h10.688c0.47-0.003,0.854,0.375,0.858,0.845v10.469 c-0.004,0.471-0.389,0.85-0.858,0.846h-10.688C-82.539-80.734-82.923-81.113-82.927-81.584L-82.927-81.584z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(550.608 534.362)",
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8716D",
    stroke: "#E8716D",
    strokeWidth: 0.5,
    d: "M-82.826-90.333v-2.81c0-0.195-0.159-0.354-0.355-0.354 c-0.196,0-0.355,0.159-0.355,0.354v2.81c0,0.196,0.159,0.354,0.355,0.354C-82.985-89.979-82.826-90.137-82.826-90.333z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(556.339 534.362)",
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8716D",
    stroke: "#E8716D",
    strokeWidth: 0.5,
    d: "M-82.825-90.333v-2.81c0-0.195-0.159-0.354-0.354-0.354 c-0.197,0-0.355,0.159-0.355,0.354v2.81c0,0.196,0.158,0.354,0.355,0.354C-82.984-89.979-82.825-90.137-82.825-90.333z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(547.34 538.457)",
    display: "inline"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -83.535,
    y: -93.498,
    fill: "#E8716D",
    stroke: "#E8716D",
    strokeWidth: 0.5,
    width: 12.833,
    height: 0.71
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(551.908 540.793)",
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8716D",
    stroke: "#E8716D",
    strokeWidth: 0.5,
    d: "M-82.066-87.946c0.178,0.08,0.388,0,0.467-0.18c0,0,0,0,0,0 l2.168-4.873c0.08-0.179,0-0.389-0.179-0.469c-0.046-0.021-0.095-0.031-0.146-0.031h-3.424c-0.196,0-0.355,0.159-0.355,0.355 s0.159,0.354,0.355,0.354h2.88l-1.946,4.372c-0.08,0.18-0.001,0.389,0.178,0.469C-82.067-87.946-82.067-87.946-82.066-87.946z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(335.9 193.207)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.031)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6A409",
    stroke: "#F6A409",
    strokeWidth: 0.5,
    d: "M-305.685-173.079c0.732,0,1.326-0.596,1.326-1.328v-9.63 c0-0.732-0.594-1.326-1.326-1.328h-9.669c-0.732,0.002-1.326,0.596-1.326,1.328v9.63c0,0.732,0.594,1.328,1.326,1.328H-305.685z  M-316.128-174.407v-9.63c0-0.428,0.346-0.775,0.775-0.776h9.669c0.428,0.001,0.775,0.349,0.775,0.776v9.63 c0,0.43-0.348,0.777-0.775,0.777h-9.669C-315.782-173.63-316.13-173.979-316.128-174.407L-316.128-174.407L-316.128-174.407z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.307)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6A409",
    stroke: "#F6A409",
    strokeWidth: 0.5,
    d: "M-316.141-182.977v-2.121c-0.002-0.148-0.121-0.268-0.27-0.268 c-0.146,0.001-0.266,0.12-0.268,0.268v2.121c0,0.147,0.119,0.268,0.268,0.269s0.268-0.119,0.27-0.267 C-316.141-182.976-316.141-182.977-316.141-182.977z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.537)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6A409",
    stroke: "#F6A409",
    strokeWidth: 0.5,
    d: "M-316.142-182.977v-2.121c0-0.148-0.119-0.269-0.268-0.269 s-0.268,0.12-0.268,0.269v2.121c0,0.147,0.119,0.268,0.268,0.268S-316.142-182.829-316.142-182.977z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.268 3.735)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -316.679,
    y: -185.366,
    fill: "#F6A409",
    stroke: "#F6A409",
    strokeWidth: 0.5,
    width: 11.726,
    height: 0.535
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.113 5.886)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6A409",
    stroke: "#F6A409",
    strokeWidth: 0.5,
    d: "M-316.041-185.047c0-0.177-0.143-0.319-0.318-0.319 c-0.178,0-0.32,0.143-0.32,0.319s0.143,0.319,0.32,0.319C-316.184-184.728-316.041-184.87-316.041-185.047L-316.041-185.047z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.589 5.886)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6A409",
    stroke: "#F6A409",
    strokeWidth: 0.5,
    d: "M-316.042-185.047c0-0.177-0.143-0.319-0.318-0.319 s-0.318,0.143-0.318,0.319s0.143,0.319,0.318,0.319S-316.042-184.87-316.042-185.047L-316.042-185.047z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.065 5.886)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6A409",
    stroke: "#F6A409",
    strokeWidth: 0.5,
    d: "M-316.041-185.047c0-0.177-0.143-0.319-0.318-0.319 s-0.32,0.143-0.32,0.319s0.145,0.319,0.32,0.319S-316.041-184.87-316.041-185.047L-316.041-185.047z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.542 5.886)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6A409",
    stroke: "#F6A409",
    strokeWidth: 0.5,
    d: "M-316.042-185.047c0-0.177-0.143-0.319-0.318-0.319 s-0.318,0.143-0.318,0.319s0.143,0.319,0.318,0.319S-316.042-184.87-316.042-185.047L-316.042-185.047z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.113 8.159)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6A409",
    stroke: "#F6A409",
    strokeWidth: 0.5,
    d: "M-316.041-185.053c0-0.176-0.143-0.318-0.318-0.318 c-0.178,0-0.32,0.143-0.32,0.318c0,0.177,0.143,0.319,0.32,0.319C-316.184-184.733-316.041-184.876-316.041-185.053 L-316.041-185.053z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.589 8.159)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6A409",
    stroke: "#F6A409",
    strokeWidth: 0.5,
    d: "M-316.042-185.053c0-0.176-0.143-0.318-0.318-0.318 s-0.318,0.143-0.318,0.318c0,0.177,0.143,0.319,0.318,0.319S-316.042-184.876-316.042-185.053L-316.042-185.053z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.065 8.159)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6A409",
    stroke: "#F6A409",
    strokeWidth: 0.5,
    d: "M-316.041-185.053c0-0.176-0.143-0.318-0.318-0.318 s-0.32,0.143-0.32,0.318c0,0.177,0.145,0.319,0.32,0.319S-316.041-184.876-316.041-185.053L-316.041-185.053z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.542 8.159)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6A409",
    stroke: "#F6A409",
    strokeWidth: 0.5,
    d: "M-316.042-185.053c0-0.176-0.143-0.318-0.318-0.318 s-0.318,0.143-0.318,0.318c0,0.177,0.143,0.319,0.318,0.319S-316.042-184.876-316.042-185.053L-316.042-185.053z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.113 10.433)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6A409",
    stroke: "#F6A409",
    strokeWidth: 0.5,
    d: "M-316.041-185.047c0-0.176-0.143-0.318-0.318-0.318 c-0.178,0-0.32,0.143-0.32,0.318s0.143,0.318,0.32,0.318C-316.184-184.729-316.041-184.871-316.041-185.047L-316.041-185.047z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.589 10.433)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6A409",
    stroke: "#F6A409",
    strokeWidth: 0.5,
    d: "M-316.042-185.047c0-0.176-0.143-0.318-0.318-0.318 s-0.318,0.143-0.318,0.318s0.143,0.318,0.318,0.318S-316.042-184.871-316.042-185.047L-316.042-185.047z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.065 10.433)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F6A409",
    stroke: "#F6A409",
    strokeWidth: 0.5,
    d: "M-316.041-185.047c0-0.176-0.143-0.318-0.318-0.318 s-0.32,0.143-0.32,0.318s0.145,0.318,0.32,0.318S-316.041-184.871-316.041-185.047L-316.041-185.047z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleWeekCircle);
export default __webpack_public_path__ + "static/media/toggle-week-circle.946e9496.svg";
export { ForwardRef as ReactComponent };